import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  header: {
    marginBottom: theme.spacing(4)
  },
  title: {
    display: 'block'
  },
  description: {
    margin: theme.spacing(1, 0, 5),
    color: theme.colorPalette.gray_03,
    fontSize: 14
  },
  form: {
    width: '100%'
  },
  field: {
    width: '100%',
    marginBottom: 0,
    '& [class*="MuiInputBase-root"]': {
      backgroundColor: theme.colorPalette.white,
      paddingRight: theme.spacing(2)
    }
  },
  searchIcon: {
    color: theme.colorPalette.gray_03
  },
  button: {
    minWidth: 96
  },
  tools: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    marginTop: theme.spacing(4)
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5)
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minHeight: 32,
    padding: theme.spacing(1, 3),
    border: `1px solid ${theme.colorPalette.beige_60}`,
    borderRadius: 999,
    backgroundColor: theme.colorPalette.white,
    color: theme.colorPalette.green_100,
    fontSize: 13,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      borderColor: theme.colorPalette.green_75
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.colorPalette.green_75}`,
      outlineOffset: 2
    }
  },
  selectedChip: {
    backgroundColor: theme.colorPalette.green_100,
    borderColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    fontWeight: 700,
    '& $chipCount, & $internalTag': {
      color: theme.colorPalette.beige_60,
      borderColor: theme.colorPalette.beige_60
    }
  },
  internalTag: {},
  chipCount: {
    color: theme.colorPalette.gray_03,
    fontWeight: 400
  },
  options: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(4)
  }
});

export default makeStyles(styles);
